<app-oee-modal
    title="Rework"
    [subtitle]="data.station ? 'Job already completed at ' + data.station : 'Job already completed at this station'"
    icon="autorenew"
    [useMaterialIcon]="true"
    iconColor="blue"
    tint="blue"
    size="sm"
    (closeClick)="onCancel()">

    <ng-container modal-content>
        <p class="rework-prompt">
            This job was completed
            @if (formattedCompletedAt) {
                on <strong>{{ formattedCompletedAt }}</strong>
            }
            @if (data.station) {
                at <strong>{{ data.station }}</strong>.
            } @else {
                at this station.
            }
            Your time entry extends past that completion.
        </p>
        <p class="rework-question">Is this <strong>rework</strong>?</p>

        <div class="rework-options" role="radiogroup" aria-label="Is this rework?">
            <button
                type="button"
                class="rework-option"
                role="radio"
                [class.selected]="answer === true"
                [attr.aria-checked]="answer === true"
                (click)="select(true)">
                <div class="rework-option-title">Yes</div>
                <div class="rework-option-detail">Reopens the job and tags this and future entries as rework.</div>
            </button>
            <button
                type="button"
                class="rework-option"
                role="radio"
                [class.selected]="answer === false"
                [attr.aria-checked]="answer === false"
                (click)="select(false)">
                <div class="rework-option-title">No</div>
                <div class="rework-option-detail">Updates the job's recorded completion to match the new time. No rework tag.</div>
            </button>
        </div>
    </ng-container>

    <ng-container modal-actions>
        <button mat-button (click)="onCancel()">Cancel</button>
        <button
            mat-raised-button
            color="primary"
            [disabled]="answer === null"
            (click)="onSubmit()">
            <mat-icon>check</mat-icon>
            Submit
        </button>
    </ng-container>

</app-oee-modal>
